/**
 * Formats production stage text with special styling for "Home Work" items
 * @param {string} rawText - The raw text property (e.g., "Classic Hairline Home Work")
 * @param {string} translatedText - The translated text
 * @returns {string} - Formatted text with HTML styling if needed
 */

const formatProductionStageText = (rawText, translatedText) => {
    const homeWorkExceptions = [
        'Classic Hairline - Home Work',
        'First Hairline Tracing - Home Work',
    ]

    const isHomeWork = homeWorkExceptions.some((exception) =>
        rawText.toLowerCase().includes(exception.toLowerCase())
    )

    if (!isHomeWork) {
        return translatedText
    }

    if (translatedText.includes('מהבית')) {
        return translatedText.replace(
            /מהבית/g,
            '<span style="color: black; font-weight: 700;">מהבית</span>'
        )
    }

    if (translatedText.toLowerCase().includes('home work')) {
        return translatedText
            .replace(/Home Work/g, 'Home work')
            .replace(/Home work/g, '<span style="color: black; font-weight: 700;">Home work</span>')
    }

    return translatedText
}

export default formatProductionStageText

